export const OWN_BRANCH_EXPENSE_CATEGORIES = [
  { value: 'pick_up_expenses', label: 'Pick up expenses' },
  { value: 'pc_expenses', label: 'Pc expenses' },
  { value: 'monthly_pc', label: 'Monthly PC' },
  { value: 'weekly_pc', label: 'Weekly PC' },
  { value: 'water_expenses', label: 'Water expenses' },
  { value: 'cc_expenses', label: 'CC Expenses' },
  { value: 'tea_coffee', label: 'Tea/coffee' },
  { value: 'office_supplies', label: 'Office supplies' },
  { value: 'meals_refreshments', label: 'Meals refreshments' },
  { value: 'cleaning', label: 'Cleaning' },
  { value: 'printing_stationery', label: 'Printing & stationary' },
  { value: 'electricity_bill', label: 'Electricity bill' },
  { value: 'pooja_expenses', label: 'Pooja expenses' },
  { value: 'porter_expenses', label: 'Porter expenses' },
  { value: 'other_expenses', label: 'Other expenses' },
];

const OWN_BRANCH_CATEGORY_VALUES = new Set(
  OWN_BRANCH_EXPENSE_CATEGORIES.map((category) => category.value),
);

export function isOwnBranchCategory(value) {
  return OWN_BRANCH_CATEGORY_VALUES.has(String(value || '').trim().toLowerCase());
}

export function categoriesForOwnBranchAgent(apiCategories) {
  const labels = {};
  (apiCategories || []).forEach((category) => {
    if (category?.value) labels[category.value] = category.label;
  });
  return OWN_BRANCH_EXPENSE_CATEGORIES.map((category) => ({
    value: category.value,
    label: labels[category.value] || category.label,
  }));
}
